<script>
    let top;
    let left;

    export { top, left };
</script>

<svg
    style="
position: absolute; 
top: {top ? top : 'auto'}; 
left: {left ? left : 'auto'};"
    width="27.1875vw"
    height="17.77777vh"
    viewBox="0 0 182 72"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
>
    <g filter="url(#filter0_d_110_647)">
        <rect
            x="4"
            width="174"
            height="64"
            rx="5"
            fill="#2400FF"
            fill-opacity="0.3"
        />
        <circle cx="32.3181" cy="32" r="9.72727" stroke="#231FFF" />
        <circle cx="33" cy="32" r="24.5" stroke="#6C54FF" />
        <path
            d="M32.6591 28.8182L34.7257 32.7286H30.5924L32.6591 28.8182Z"
            fill="#9E00FF"
            fill-opacity="0.8"
        />
        <path
            d="M32.6591 29.5134L34.7257 33.4238H30.5924L32.6591 29.5134Z"
            fill="#6D00AF"
            fill-opacity="0.8"
        />
        <rect x="67" y="8" width="9" height="9" fill="#00FAA0" />
        <rect x="67" y="21" width="9" height="9" fill="#4F60FF" />
        <rect x="67" y="34" width="9" height="9" fill="#2F1D9C" />
        <rect x="67" y="47" width="9" height="9" fill="#2F1D9C" />
        <rect x="80" y="8" width="9" height="9" fill="#2F1D9C" />
        <rect x="80" y="21" width="9" height="9" fill="#2F1D9C" />
        <rect x="80" y="34" width="9" height="9" fill="#2F1D9C" />
        <rect x="80" y="47" width="9" height="9" fill="#2F1D9C" />
        <rect x="93" y="8" width="9" height="9" fill="#2F1D9C" />
        <rect x="93" y="21" width="9" height="9" fill="#2F1D9C" />
        <rect x="93" y="34" width="9" height="9" fill="#2F1D9C" />
        <rect x="93" y="47" width="9" height="9" fill="#2F1D9C" />
        <rect x="112" y="14" width="27" height="4" rx="2" fill="#5C41FF" />
        <rect x="112" y="24" width="27" height="4" rx="2" fill="#5C41FF" />
        <rect x="112" y="34" width="27" height="4" rx="2" fill="#5C41FF" />
        <rect x="112" y="44" width="27" height="4" rx="2" fill="#5C41FF" />
        <rect x="143" y="14" width="19" height="4" rx="2" fill="#5C41FF" />
        <rect x="143" y="24" width="15" height="4" rx="2" fill="#5C41FF" />
        <rect x="143" y="34" width="30" height="4" rx="2" fill="#5C41FF" />
        <rect x="143" y="44" width="24" height="4" rx="2" fill="#5C41FF" />
    </g>
    <defs>
        <filter
            id="filter0_d_110_647"
            x="0"
            y="0"
            width="182"
            height="72"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
        >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
            />
            <feOffset dy="4" />
            <feGaussianBlur stdDeviation="2" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
            />
            <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_110_647"
            />
            <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow_110_647"
                result="shape"
            />
        </filter>
    </defs>
</svg>
